import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseKindRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseEnterpriseKind"
);

export default {
  async getEnterpriseKind({ commit, _state }) {
    const res = await enterpriseKindRepository.fetch();
    if (res.status) {
      await commit("SET_ENTERPRISE_KIND", res.data);
      return res.data;
    } else {
      return null;
    }
    // ログアウト後もstateがクリアされないため一旦コメントアウト
    /*
    if (state.enterpriseKind == null) {
      const res = await enterpriseKindRepository.fetch();
      if (res.status) {
        await commit("SET_ENTERPRISE_KIND", res.data);
        return res.data;
      } else {
        return null;
      }
    } else {
      return state.enterpriseKind;
    }
    */
  },
};
